// TRIUMPH-GALERIE: vylepseni product-modal lightboxu (sipky + swipe + pocitadlo + tap-zoom).
// Aditivni vrstva nad Athens product-modal.js - je zavisla jen na .is-active
// (nastavuje showActiveMedia v sablone) a eventu product:modal-open.
(function () {
  function init(modal) {
    if (modal.dataset.tvcGalerie) return;
    var content = modal.querySelector('.product-media-modal-content');
    var dialog = modal.querySelector('.product-media-modal-dialog');
    if (!content || !dialog) return;
    var media = content.querySelectorAll('[data-media-id]');
    if (media.length < 2) return; // jedina fotka -> puvodni chovani staci
    modal.dataset.tvcGalerie = '1';
    content.classList.add('tvc-galerie');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'tvc-gal-sipka tvc-gal-prev';
    prev.setAttribute('aria-label', 'Předchozí fotka');
    prev.innerHTML = '‹';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'tvc-gal-sipka tvc-gal-next';
    next.setAttribute('aria-label', 'Další fotka');
    next.innerHTML = '›';
    var pocitadlo = document.createElement('div');
    pocitadlo.className = 'tvc-gal-pocitadlo';
    dialog.appendChild(prev);
    dialog.appendChild(next);
    dialog.appendChild(pocitadlo);

    function seznam() {
      return Array.prototype.slice.call(content.querySelectorAll('[data-media-id]'));
    }
    function aktivni() {
      var l = seznam();
      for (var i = 0; i < l.length; i++) if (l[i].classList.contains('is-active')) return i;
      return 0;
    }
    function ukaz(i) {
      var l = seznam();
      i = ((i % l.length) + l.length) % l.length;
      l.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      content.classList.remove('tvc-zoom');
      content.scrollTop = 0; content.scrollLeft = 0;
      pocitadlo.textContent = (i + 1) + ' / ' + l.length;
    }
    modal.tvcSync = function () { ukaz(aktivni()); };

    prev.addEventListener('click', function (e) { e.stopPropagation(); ukaz(aktivni() - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); ukaz(aktivni() + 1); });

    var sx = 0, sy = 0;
    content.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    content.addEventListener('touchend', function (e) {
      if (content.classList.contains('tvc-zoom')) return; // pri zoomu se posouva, nelistuje
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) ukaz(aktivni() + (dx < 0 ? 1 : -1));
    }, { passive: true });

    content.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-media-id') && e.target.tagName === 'IMG') {
        content.classList.toggle('tvc-zoom');
      }
    });
    modal.addEventListener('keyup', function (e) {
      if (e.key === 'ArrowRight') ukaz(aktivni() + 1);
      if (e.key === 'ArrowLeft') ukaz(aktivni() - 1);
    });
  }

  function initAll() {
    document.querySelectorAll('product-modal').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('product:modal-open', function () {
    initAll();
    document.querySelectorAll('product-modal').forEach(function (m) {
      if (m.tvcSync && m.hasAttribute('open')) m.tvcSync();
    });
  });
})();
